import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection } from '../../shared/sociedadeSections';
import { enderecoComercialStep, DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL } from '../../shared/enderecoSections';
import { CAMPOS_ASSOCIACAO_SOCIEDADES, CERTIDAO_REGULARIDADE_OUTRA_SECCIONAL, PAGAMENTO_POR_SOCIEDADE } from '../../shared/associacaoSociedadesSections';

const pedidoContratoAssociacaoSociedadesConfig = {
  id: 'pedido_contrato_associacao_sociedades',
  nome: 'Pedido de Contrato de Associação entre Sociedades de Advogados',
  descricao: 'Solicitação de registro de contrato de associação entre sociedades de advogados',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contrato', tipoDocumentoProcesso: 538, name: 'Contrato', description: 'Contrato de associação entre as sociedades', required: true }
    ],
    conditional: [CERTIDAO_REGULARIDADE_OUTRA_SECCIONAL]
  },

  paymentConfig: PAGAMENTO_POR_SOCIEDADE,

  protocoloConfig: {
    modeloRequerimento: '276',
    tiposAssunto: '822',
    tipoPedido: '476'
  },

  // Sem campos pessoais mapeáveis (Nome/CPFCNPJ na API não têm campo local
  // correspondente — só nomeSociedade/cnpj) — só o endereço comercial completo
  // da sociedade (grupo "Comercial" da API).
  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL,

  tituloConfig: {
    tipoLancamentoId: 144,
    enderecoOrigem: 'comercial'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection(CAMPOS_ASSOCIACAO_SOCIEDADES)
      ]
    },
    // Endereço comercial completo, igual ao Distrato de Associação.
    enderecoComercialStep({ autoCep: true, id: 'endereco' }),
    termosStep()
  ]
};

export default pedidoContratoAssociacaoSociedadesConfig;
